module.exports = __webpack_public_path__ + "img/mpw.57973ab5.jpg";